import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'

import { BkFlowCheckbox } from '../elements/BkFlowCheckbox'

// Guest form validation rules
const validate = values => {
	const errors = {}

	if (!values.termsConditions) {
		errors.termsConditions = 'Required'
	}

	return errors
}

class TermsConditionsField extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}

	render() {
		const { configData } = this.props
		const hotelLabels = configData.hotel.labels[0],
					coreLinks = configData.core.options.links

		return (
			<form className="bk-flow-payment__terms-conditions">
				{ process.env.REACT_APP_COMPONENT_GUEST_FORM_EMAIL_CONSENT === 'terms-conditions' &&
					<div className="u-form-group group-terms-email-consent">
						<Field
							name="emailOptIn"
							type="checkbox"
							size="xl"
							component={ BkFlowCheckbox }
							required={ false }
							label={ hotelLabels.emailOptIn ? hotelLabels.emailOptIn : 'I want to receive property and stay notifications' }
							labelClasses="u-form-label start-xs col-xs u-remove-margin"
						/>
					</div>
				}

				{ process.env.REACT_APP_COMPONENT_GUEST_FORM_SMS_CONSENT === 'terms-conditions' &&
					<div className="u-form-group group-sms-consent">
						<Field
							name="textOptIn"
							type="checkbox"
							size="xl"
							component={ BkFlowCheckbox }
							required={ false }
							label={ hotelLabels.textConsent ? hotelLabels.textConsent : 'I consent to receive text notifications' }
							labelClasses="u-form-label start-xs col-xs u-remove-margin"
						/>
					</div>
				}

				<div className="u-form-group group-terms-conditions">
					<Field
						name="termsConditions"
						type="checkbox"
						size="xl"
						component={ BkFlowCheckbox }
						required={ true }
						label={ hotelLabels.agreeTermsConditions ? hotelLabels.agreeTermsConditions : 'Terms & Conditions' }
						labelClasses="u-form-label start-xs col-xs u-remove-margin"
						labelLink={ coreLinks.brandTermsConditionsLink }
						labelLinkText={ '(' + hotelLabels.view + ')' }
					/>
				</div>
			</form>
		)
	}
}

export default reduxForm({
	validate,
	destroyOnUnmount: false,
	keepDirtyOnReinitialize: true
})(TermsConditionsField)


// WEBPACK FOOTER //
// ./src/components/forms/termsConditions/TermsConditionsField.js